import React from "react";
import {
  ScreenFlow,
  RecruitmentSteps,
} from "../../components";

const flowarray = [
  { title: "Home", link: "/" },
  { title: "Find Trials", link: "/#find_trial" },
  {
    title: "Search Results",
    link: `/results?q=NCT03288545&in=UNITED%20STATES`,
  },
  {
    title: "Trial Details",
    link: `/study/NCT03288545`,
  },
];

class NCT03288545 extends React.Component {
  
  render() {
    return (
      <div>
        {this.props.location &&
        this.props.location.search &&
        this.props.location.search.indexOf("embed=true") !== -1 ? null : (
          <>
            <RecruitmentSteps step={"Review Trials"} />
            <div className="container d-flex align-items-center justify-content-start">
              <ScreenFlow flow={flowarray} />
            </div>
          </>
        )}
        <div className="container">
          <iframe style={{height:2600,width:'100%',border:'none'}} title="NCT03288545" src="https://connect.trialscope.com/studies/75d251be-c6af-47ca-9002-f4dbff0ae87a?embed=1"></iframe>
        </div>
      </div>
    );
  }
}

export default NCT03288545;
